<template>
  <div>
    <report-hero>
      <h3 class="title">Hi<span v-if="get_first_name" v-text="` ${ get_first_name }`" />, <br>your report is ready</h3>
    </report-hero>
    <top5-domains />
    <start-free-trial class="hide-in-mobile"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ReportHero from "@/components/report/2/Hero";
import Top5Domains from "@/components/report/2/Top5Domains";
import StartFreeTrial from "@/components/global/StartFreeTrial";

export default {
  name: "MultipleDomains",
  components: {
    ReportHero,
    Top5Domains,
    StartFreeTrial,
  },
  computed: {
    ...mapGetters(['get_first_name']),
  },
}
</script>